









































/** @format */

import { Vue, Component, Mixins } from 'vue-property-decorator';
import * as routeNames from '../router-names';
import { queryOrderPayDetail } from '../../../api/order-management';
import GoBackWithCloseTab from '@root/common/mixins/go-back-with-close-tab';
import { isShiDaill } from '@root/utils/env';
@Component
export default class EnergyRecordDetail extends Mixins(GoBackWithCloseTab) {
  path = '/smart-parking/order-management/trade-record-list';
  navs = [
    {
      label: '交易记录',
      location: {
        name: routeNames.TRADE_RECORD_LIST
      }
    },
    {
      label: '交易记录详情'
    }
  ];
  detailModel: any = {};
  private parkId = '';
  private pkPayId = '';

  private created() {
    this.init();
    this.queryOrderPay();
  }

  private init() {
    this.parkId = this.$route.query.parkId as string;
    this.pkPayId = this.$route.query.pkPayId as string;
  }
  isshidaill: boolean = isShiDaill;
  private async queryOrderPay() {
    try {
      const { status, msg, code, data = {} } = await queryOrderPayDetail({
        parkId: this.parkId,
        pkPayId: this.pkPayId
      });
      if (status !== '9999') {
        this.$message.error(msg);
      }
      if (data) {
        this.detailModel = data;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryOrderEnterDetail,出现错误', error);
    }
  }

  enterDetail = [
    {
      prop: 'enterTime',
      label: '进场时间'
    },
    {
      prop: 'authTypeName',
      label: '车辆类型'
    },
    {
      prop: 'authorizDate',
      label: '授权期限'
    },
    {
      prop: 'userName',
      label: '姓名'
    },
    {
      prop: 'userTel',
      label: '联系电话'
    },
    {
      prop: 'carType',
      label: '车型'
    }
  ];
  orderPayDetail = [
    {
      prop: 'payChannelName',
      label: '支付渠道'
    },
    {
      prop: 'payMethodName',
      label: '支付方式'
    },
    {
      prop: 'orderId',
      label: '停车订单号',
      render(h: any, params: any) {
        const { orderId = '' } = params.data;
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: orderId
            }
          },
          [
            h(
              'div',
              {
                class: 'mixin-text-ellipse',
                attrs: {
                  style: 'width:140px'
                }
              },
              orderId || '-'
            )
          ]
        );
      }
    },
    {
      prop: 'totalAmount',
      label: '应收金额',
      render(h: any, params: any) {
        const { totalAmount } = params.data;
        return h('div', ((+totalAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'paidAmount',
      label: '实收金额',
      render(h: any, params: any) {
        const { paidAmount } = params.data;
        return h('div', ((+paidAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'discountAmount',
      label: '优惠金额',
      render(h: any, params: any) {
        const { discountAmount } = params.data;
        return h('div', ((+discountAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'unpaidAmount',
      label: '应收未收',
      render(h: any, params: any) {
        const { unpaidAmount } = params.data;
        return h('div', ((+unpaidAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'cancelAmount',
      label: '减免金额',
      render(h: any, params: any) {
        const { cancelAmount } = params.data;
        return h('div', ((+cancelAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'paidTime',
      label: '交易时间'
    }
  ];
  discountTableColums = [
    {
      title: '优惠来源',
      dataIndex: 'fromTypeName'
    },
    {
      title: '商家名称',
      dataIndex: 'merchantName'
    },
    {
      title: '优惠类型',
      dataIndex: 'couponTypeName'
    },
    {
      title: '优惠名称',
      dataIndex: 'couponName'
    },
    {
      title: '优惠数额',
      dataIndex: 'couponValue'
      // customRender: (text: any, record: any, index: number) => ((+text).toFixed(2) || '0.00') + '元',
    },
    {
      title: '券号',
      dataIndex: 'couponId'
    },
    {
      title: '优惠发放时间',
      dataIndex: 'sendTime'
    },
    {
      title: '抵扣金额',
      dataIndex: 'currDiscPrice'
      // customRender: (text: any, record: any, index: number) => ((+text).toFixed(2) || '0.00') + '元',
    }
  ];
  orderRemark = [
    {
      prop: 'remark',
      label: '备注:',
      render(h: any, params: any) {
        let remark = '';
        if (this.isshidaill && params.data.authTypeName === '访客车') {
          if (params.data.payer === '01') {
            remark = '业主代缴';
          } else if (params.data.payer === '00') {
            remark = '不是代缴';
          } else {
            remark = '-';
          }
        } else {
          remark = params.data.remark || '-';
        }
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: remark
            }
          },
          [
            h(
              'div',
              {
                class: 'mixin-text-ellipse',
                attrs: {
                  style: 'width:140px'
                }
              },
              remark
            )
          ]
        );
      }
    }
  ];
}
